<div class="text" translate>
  PHONE.AGENT_ONLINE.RANDOM_CASCADE_DESCRIPTION
</div>
